import React from "react";
import Packages from "../components/Packages";
import { PACKAGES } from "../utils/constants";

export default function PackagesPage({ data, refresh, goTab }) {
  if (!data.registered) {
    return (
      <div className="card center fade-up" style={{ marginTop: 24 }}>
        <h2 className="card-title">Activate first</h2>
        <p className="muted">Register your node on the Home tab to unlock packages.</p>
        <button className="btn mt-4" onClick={() => goTab("home")}>Go to Home</button>
      </div>
    );
  }

  const active = data.packages ? data.packages.filter(Boolean).length : 0;
  const highest =
    data.packages && active > 0
      ? PACKAGES[data.packages.map(Boolean).lastIndexOf(true)].label
      : "—";

  return (
    <div className="stagger">
      <div className="grid grid-2 mb-4">
        <div className="stat stat-accent">
          <div className="label">Active Packages</div>
          <div className="value grad-text">{active} / 9</div>
        </div>
        <div className="stat stat-accent">
          <div className="label">Highest Tier</div>
          <div className="value" style={{ fontSize: 15 }}>{highest}</div>
        </div>
      </div>
      <Packages
        packages={data.packages}
        packageDetails={data.packageDetails}
        usdtBal={data.usdtBal}
        onDone={refresh}
      />
    </div>
  );
}
